/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Delivery_Avg_HoursInputs */

const vi_report_delivery_avg_hours = /** @type {(inputs: Report_Delivery_Avg_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TB giờ giao`)
};

/**

* @param {Report_Delivery_Avg_HoursInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_delivery_avg_hours = /** @type {((inputs?: Report_Delivery_Avg_HoursInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Delivery_Avg_HoursInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_delivery_avg_hours(inputs)
});